import { gql, useQuery, type ApolloError } from '@apollo/react-hooks';
import { DsrcApprovalDecision } from '../../../DRCApproval/components/options';

export type DsrcApproval = {
  approveDoRPgSInTeam: DsrcApprovalDecision;
  remarks: string;
};

type GetDsrcApproval = {
  dsrcApprovalCreated: boolean;
  dsrcApproval: DsrcApproval;
  drcRequired: boolean;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetDsrcApproval = (applicationId: string): GetDsrcApproval => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($input: AssessmentFilter!) {
        dsrcInterestConflictApproval(input: $input) {
          approveDoRPgSInTeam
          remarks
        }
        dsrcAdmission(filter: $input) {
          confirmationDoRPgSInTeam
          confirmationChairInTeam
        }
      }
    `,
    {
      variables: { input: { applicationId } },
      fetchPolicy: 'network-only',
      skip: !applicationId,
    },
  );
  const dsrcApprovalCreated = Boolean(data?.dsrcInterestConflictApproval);
  const dsrcApproval: DsrcApproval = {
    approveDoRPgSInTeam:
      data?.dsrcInterestConflictApproval?.approveDoRPgSInTeam ??
      DsrcApprovalDecision.NA,
    remarks: data?.dsrcInterestConflictApproval?.remarks ?? '',
  };

  const hasDoRPgSInTeam: boolean =
    data?.dsrcAdmission?.confirmationDoRPgSInTeam ?? false;

  const hasChairInTeam: boolean =
    data?.dsrcAdmission?.confirmationChairInTeam ?? false;

  const drcRequired = !hasChairInTeam && hasDoRPgSInTeam;

  return {
    dsrcApprovalCreated,
    dsrcApproval,
    drcRequired,
    loading,
    error,
    refetch,
  };
};
